'use strict';

var UseSize = require('../UseSize-b7bfbcb4.js');
var _tslib = require('../_tslib-17936c8d.js');
var React = require('react');
var UseHasMounted = require('../UseHasMounted-b444dd79.js');
require('../ResponsiveSizes-61db354a.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

var useShare = function (_a) {
    var title = _a.title, url = _a.url, _b = _a.text, text = _b === void 0 ? '' : _b, facebookAppId = _a.facebookAppId, _c = _a.facebookWebIntentShare, facebookWebIntentShare = _c === void 0 ? 'https://www.facebook.com/dialog/share' : _c, _d = _a.twitterWebIntentShare, twitterWebIntentShare = _d === void 0 ? 'https://twitter.com/intent/tweet' : _d;
    var handleShare = function () { return _tslib.__awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return _tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.share({
                            title: title,
                            text: "".concat(text, " ").concat(url),
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error('Failed to share', e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleShareTwitter = function () {
        var params = new URLSearchParams({ text: text, url: url });
        window.open("".concat(twitterWebIntentShare, "?").concat(params.toString()), '_blank');
    };
    var handleShareFacebook = function () {
        var params = new URLSearchParams({
            app_id: facebookAppId,
            display: 'popup',
            href: url,
            redirect_uri: url,
        });
        window.open("".concat(facebookWebIntentShare, "?").concat(params.toString()), '_blank');
    };
    var handleCopyLink = function () { return _tslib.__awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return _tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(url)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    console.error('Failed to copy link', e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var canShare = typeof window !== 'undefined' && 'share' in navigator;
    return { canShare: canShare, handleShare: handleShare, handleCopyLink: handleCopyLink, handleShareFacebook: handleShareFacebook, handleShareTwitter: handleShareTwitter };
};

var useGallerySwiper = function (_a) {
    var _b;
    var cardSize = _a.cardSize, cardSpacing = _a.cardSpacing, slideCount = _a.slideCount;
    var _c = _tslib.__read(React__default.default.useState(), 2), swiper = _c[0], setSwiper = _c[1];
    var _d = _tslib.__read(React__default.default.useState((_b = swiper === null || swiper === void 0 ? void 0 : swiper.progress) !== null && _b !== void 0 ? _b : 0), 2), progress = _d[0], setProgress = _d[1];
    var _e = _tslib.__read(React__default.default.useState(0), 2), currentIndex = _e[0], setCurrentIndex = _e[1];
    var swipeLeft = function () {
        var newIndex = currentIndex - 1 < 0 ? 0 : currentIndex - 1;
        setCurrentIndex(newIndex);
        swiper === null || swiper === void 0 ? void 0 : swiper.translateTo(newIndex * -(cardSize + cardSpacing), 200, true, false);
    };
    var swipeRight = function () {
        var newIndex = currentIndex + 1 > slideCount - 1 ? slideCount - 1 : currentIndex + 1;
        setCurrentIndex(newIndex);
        swiper === null || swiper === void 0 ? void 0 : swiper.translateTo(newIndex * -(cardSize + cardSpacing), 200, true, false);
    };
    var onSwiper = function (newSwiper) { return setSwiper(newSwiper); };
    var onSetTranslate = function (_, translate) {
        setCurrentIndex(Math.round(Math.abs(translate) / (cardSize + cardSpacing)));
    };
    var onProgress = function (_, newProgress) {
        setProgress(newProgress);
    };
    var canSwipeLeft = progress <= 0;
    var canSwipeRight = progress >= 1;
    return {
        canSwipeLeft: canSwipeLeft,
        canSwipeRight: canSwipeRight,
        swipeLeft: swipeLeft,
        swipeRight: swipeRight,
        swiperEvents: {
            onSwiper: onSwiper,
            onProgress: onProgress,
            onSetTranslate: onSetTranslate,
        },
    };
};

exports.getResponsiveProperty = UseSize.getResponsiveProperty;
exports.getValueBySize = UseSize.getValueBySize;
exports.useDocumentHeight = UseSize.useDocumentHeight;
exports.useIsomorphicEffect = UseSize.useIsomorphicEffect;
exports.useSizes = UseSize.useSizes;
exports.useHasMounted = UseHasMounted.useHasMounted;
exports.useGallerySwiper = useGallerySwiper;
exports.useShare = useShare;
//# sourceMappingURL=index.js.map
